import type { IntakeLane } from '../types/intake.types'

export const GUIDED_STUDIO_INTAKE_MODE_QUERY_KEY = 'gsMode'
export const GUIDED_STUDIO_INTAKE_LANE_QUERY_KEY = 'gsLane'
export const GUIDED_STUDIO_INTAKE_MODE_VALUE = 'intake'

export const GUIDED_STUDIO_INTAKE_PACKET_READY_EVENT =
  'guidedstudio:intake:packet:ready'
export const GUIDED_STUDIO_INTAKE_COMPILE_PREVIEW_EVENT =
  'guidedstudio:intake:compilePreview:request'
export const GUIDED_STUDIO_INTAKE_DRAFT_SAVE_EVENT =
  'guidedstudio:intake:draft:save'
export const GUIDED_STUDIO_INTAKE_OPEN_REQUEST_EVENT =
  'guidedstudio:intake:open:request'

export const GUIDED_STUDIO_INTAKE_LAST_PACKET_STORAGE_KEY =
  'guidedstudio:intake:last-packet'
export const GUIDED_STUDIO_INTAKE_LAST_DRAFT_STORAGE_KEY =
  'guidedstudio:intake:last-draft'
export const GUIDED_STUDIO_INTAKE_LAST_COMPILE_REQUEST_STORAGE_KEY =
  'guidedstudio:intake:last-compile-request'
export const GUIDED_STUDIO_INTAKE_LAST_CLARIFICATION_RETURN_STORAGE_KEY =
  'guidedstudio:intake:last-clarification-return'
export const GUIDED_STUDIO_INTAKE_CLARIFICATION_RETURN_EVENT =
  'guidedstudio:intake:clarification:return'

const VALID_LANES: IntakeLane[] = [
  'idea_seed',
  'storyboard',
  'script_shot',
  'moodboard',
  'existing_software',
  'mixed_material',
]

export const normalizeIntakeLane = (
  lane: string | null | undefined,
): IntakeLane => {
  if (!lane) return 'idea_seed'
  return VALID_LANES.includes(lane as IntakeLane)
    ? (lane as IntakeLane)
    : 'idea_seed'
}

export const isGuidedStudioIntakeOpen = (
  searchParams: URLSearchParams,
): boolean =>
  searchParams.get(GUIDED_STUDIO_INTAKE_MODE_QUERY_KEY) ===
  GUIDED_STUDIO_INTAKE_MODE_VALUE

export const buildOpenGuidedStudioIntakeSearchParams = (
  searchParams: URLSearchParams,
  lane: IntakeLane = 'idea_seed',
): URLSearchParams => {
  const next = new URLSearchParams(searchParams)
  next.set(
    GUIDED_STUDIO_INTAKE_MODE_QUERY_KEY,
    GUIDED_STUDIO_INTAKE_MODE_VALUE,
  )
  next.set(GUIDED_STUDIO_INTAKE_LANE_QUERY_KEY, lane)
  return next
}

export const buildCloseGuidedStudioIntakeSearchParams = (
  searchParams: URLSearchParams,
): URLSearchParams => {
  const next = new URLSearchParams(searchParams)
  next.delete(GUIDED_STUDIO_INTAKE_MODE_QUERY_KEY)
  next.delete(GUIDED_STUDIO_INTAKE_LANE_QUERY_KEY)
  return next
}
